/**
 * Параметр показывающий зашел ли пользователь с десктопа
 */
export const isDesktop = window.app && window.app.isDesktop
